import { toast } from "react-toastify"
import React, { useEffect, useState } from "react"
import { MenuButton, MenuItem } from "@headlessui/react"

import Config from "../../api/Config"
import { IDAM } from "../../api/Registry"
import { ErrorState } from "../errors/ErrorState"
import { APPLICATION } from "../../utils/Constants"
import DropDown from "../../lib/fragments/DropDown"
import { RouteHydration } from "../../utils/Helpers"
import HttpServices from "../../services/HttpServices"
import { Loading } from "../../components/utils/Loading"
import { FullScreenModal } from "../../lib/fragments/FullScreenModal"
import { FloatingInput } from "../../components/utils/FloatingInput"
import { G_onInputBlurHandler, G_onInputChangeHandler } from "../../components/utils/InputHandlers"


export const AddAuthProvider = ({ show, showOrHide, reload }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'pending',
        selected: {
            provider: null
        },
        data: {
            catalog: null,
        }, input: {
            slug: '',
            name: '',
        }, errors: {
            name: '',
        }
    })

    const [copied, setCopied] = useState(false);
    const redirectURL = `${Config.APP_CORE}/api/v1/identity/auth/google/callback`

    const keyMapping: Record<string, string> = {
        GOOGLE_CLIENT_ID: "Google Client ID",
        GOOGLE_CLIENT_SECRET: "Google Client Secret",
    };

    useEffect(() => {
        if (show) {
            const fetchAuthProvidersCatalog = async () => {
                setstate((prev: any) => ({
                    ...prev,
                    posting: false,
                    status: 'pending',
                    selected: {
                        provider: null
                    },
                    input: {
                        ...prev.input,
                        slug: '',
                        name: '',
                    }
                }))

                let { httpStatus, status, data } = state

                try {
                    const response: any = await HttpServices.httpGet(IDAM.PROVIDER_CATALOG)
                    httpStatus = response.status

                    if (httpStatus === 200) {
                        const payload: any = response.data.payload
                        data.catalog = payload.catalog

                        status = 'fulfilled'
                    } else {
                        status = 'rejected'
                    }
                } catch (error) {
                    status = 'rejected'
                    httpStatus = 0
                }

                setstate((prevState: any) => ({
                    ...prevState,
                    status,
                    httpStatus,
                    data: {
                        ...prevState.data,
                    },
                }))
            }

            fetchAuthProvidersCatalog()
        }
    }, [show])

    const checkIfFormIsPostingData = () => {
        showOrHide()
    }

    const authProviderCatalogHandler = (provider: any) => {
        let { posting } = state
        if (posting) return

        setstate((prev: any) => {
            const config = provider?.c;

            // Destructure to improve readability
            const { slug, name } = prev.input;
            const { name: errorName } = prev.errors;

            console.log('slug', slug);
            console.log('name', name);

            // Initialize new input and errors
            const newInput: Record<string, string> = {
                slug: provider.s,
                name: provider.e,
            };
            const newErrors: Record<string, string> = { name: errorName };

            // If config is not available, return state without modification
            if (!config) {
                return {
                    ...prev,
                    input: newInput,
                    errors: newErrors,
                    selected: {
                        ...prev.selected,
                        provider,
                    },
                };
            }

            // Update newInput and newErrors based on config
            Object.keys(config).forEach((key) => {
                newInput[key] = '';
                newErrors[key] = '';
            });

            return {
                ...prev,
                input: newInput,
                errors: newErrors,
                selected: {
                    ...prev.selected,
                    provider,
                },
            };
        });
    }

    const onFormSubmitHandler = (e: any) => {
        e.preventDefault()

        let { posting, input } = state
        if (posting) return

        let validity = true

        if (!input.slug) {
            return
        }

        if (validity) {
            setstate((prev) => ({
                ...prev,
                posting: !prev.posting
            }))

            configureNewAuthProvider()
        }
    }

    const configureNewAuthProvider = async () => {
        let { input, httpStatus, selected } = state

        try {
            const authProviderActionRoute = [":slug"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [input.slug][index]),
                    IDAM.PROVIDER_CONFIG
                );

            let formData = new FormData()

            Object.keys(selected.provider?.c).forEach((key) => {
                // Loop through provider configs
                formData.append(key, input[key])
            });

            const response: any = await HttpServices.httpPost(authProviderActionRoute, formData)
            httpStatus = response.status

            console.log('response', response);

            if (httpStatus === 200) {
                showOrHide()
                reload()
            } else {
                toast.error(APPLICATION.ERR_MSG)
            }
        } catch (error) {
            toast.error(APPLICATION.ERR_MSG)
        }

        setstate((prev) => ({
            ...prev,
            posting: false,
        }));
    }

    const onChangeHandler = (e: any) => {
        let { posting } = state
        if (posting) return

        let { input } = state
        let { errors } = state
        let output: any = G_onInputChangeHandler(e)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onInputBlur = (e: any) => {
        let { posting } = state
        if (posting) return

        let { input } = state
        let { errors } = state

        const errorMsgTitle = keyMapping[e.target.name] ?? ''
        let output: any = G_onInputBlurHandler(e, errorMsgTitle, 3, 400)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const copyRedirectURLHandler = async () => {
        try {
            await navigator.clipboard.writeText(redirectURL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    }

    return (
        <React.Fragment>
            <FullScreenModal
                show={show}
                showOrHide={showOrHide}
                content={
                    <>
                        {
                            state.status === 'rejected' ? (
                                <div className="py-2 px-6 w-full flex items-center justify-center h-full">
                                    <div className="lg:w-[550px] md:w-[550px] w-full mx-auto py-4">
                                        <ErrorState
                                            code={500}
                                        />

                                        <div className="px-4 sm:px-6 flex align-middle items-center justify-center md:bg-inherit bg-gray-100 dark:bg-gray-900 dark:md:bg-inherit">
                                            <button type="button" className="text-sm flex-none shadow-none px-3 py-1 bg-inherit text-primary dark:text-gray-400 hover:text-secondary dark:hover:text-gray-300 hover:underline hover:cursor-pointer sm:w-auto sm:text-sm" onClick={checkIfFormIsPostingData}>
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : state.status === 'fulfilled' ? (
                                <>
                                    <div className="w-full px-2 h-full mx-auto flex md:flex-row flex-col gap-3 md:px-2.5 py-3 bg-gray-100 dark:bg-gray-800 md:overflow-hidden overflow-y-auto">
                                        <div className="md:w-2/5 flex-none w-full px-2.5 md:px-2 pb-2 pt-2 sm:pb-2 flex flex-row-reverse">
                                            <div className="lg:w-2/3 w-full flex md:flex-col flex-col gap-3">
                                                <div className="md:text-2xl text-xl mb- md:mt-0 mt-4 capitalize text-gray-800 dark:text-gray-100 flex gap-x-3 md:flex-col flex-row align-middle md:items-start items-center">
                                                    Add Auth Provider
                                                </div>

                                                <span className="text-sm text-left text-slate-600 dark:text-slate-400">
                                                    Set up a new authentication provider for users to sign in to the system.
                                                </span>
                                            </div>
                                        </div>

                                        <div className="md:flex-1 flex-grow bg-white dark:bg-gray-900 border dark:border-gray-700 border-gray-300 rounded-md w-full flex flex-col md:overflow-y-auto">
                                            <div className="absolute top-0 right-0 w-full md:w-auto z-10">
                                                <div className="md:px-2 px-2 md:py-2 py-1.5 md:bg-inherit dark:md:bg-inherit bg-gray-100 dark:bg-gray-800/80 md:backdrop-blur-none backdrop-blur-sm bg-opacity-65 w-full flex flex-row-reverse">
                                                    <button onClick={showOrHide} className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 cursor-pointer text-sm">
                                                        <svg className="size-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>

                                            <form className="md:flex-1 w-full md:min-h-auto min-h-full md:px-6 px-4 md:pt-4 pt-2" onSubmit={onFormSubmitHandler}>
                                                <div className="flex w-full min-h-full flex-col">
                                                    <div className="w-full mb-2 md:pt-0 pt-1">
                                                        <p className="md:text-base text-lg text-slate-900 dark:text-white font-medium">
                                                            Choose a provider:
                                                        </p>
                                                    </div>

                                                    <div className="w-full lg:w-3/5 flex-grow">
                                                        <div className="w-full pt-3 md:w-[350px]">
                                                            <DropDown
                                                                type='custom'
                                                                button={
                                                                    <MenuButton className="w-full flex gap-x-1 items-center align-middle border border-slate-300 dark:border-slate-600 rounded-md pl-3 pr-2 py-1 text-sm dark:data-[focus]:bg-slate-700 data-[focus]:bg-slate-200 data-[focus]:text-secondary">
                                                                        {
                                                                            state.input.slug ? (
                                                                                <span className="flex-grow text-start text-slate-600 dark:text-slate-300">
                                                                                    {state.input.name}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="flex-grow text-start text-slate-600 dark:text-slate-300">
                                                                                    Auth Provider
                                                                                </span>
                                                                            )
                                                                        }

                                                                        <div className="flex-none w-5 flex items-center justify-center">
                                                                            <span className="fa-regular fa-chevron-down block"></span>
                                                                        </div>
                                                                    </MenuButton>
                                                                }
                                                                items={
                                                                    <div className="w-full text-slate-700 dark:text-slate-400">
                                                                        {
                                                                            state.data.catalog.map((catalog: any) => (
                                                                                <MenuItem key={`auth-provd-${catalog.g}`}>
                                                                                    <button type="button" onClick={() => authProviderCatalogHandler(catalog)}
                                                                                        className="w-full rounded-md px-3 py-2 text-sm data-[focus]:bg-slate-200 dark:data-[focus]:bg-slate-700 data-[focus]:text-slate-900 dark:data-[focus]:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-800">
                                                                                        <div className="w-full cursor-pointer">
                                                                                            <span className="text-start block">
                                                                                                {catalog.e}
                                                                                            </span>
                                                                                        </div>
                                                                                    </button>
                                                                                </MenuItem>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                }
                                                            />
                                                        </div>

                                                        {
                                                            state.selected.provider?.c && (
                                                                <div className="w-full pt-4">
                                                                    <label className="block text-sm text-muted py-2 dark:text-gray-400">
                                                                        Configure the required credentials and settings, and enabling the method for user access.
                                                                    </label>

                                                                    <span className="text-red-500 dark:text-red-500 text-xs block py-1 mb-5">* Required</span>

                                                                    <div className="w-full">
                                                                        {
                                                                            Object.entries(state.selected.provider.c).map(([key]) => {
                                                                                return (
                                                                                    <div key={key} className="w-full mb-5">
                                                                                        <FloatingInput
                                                                                            name={key}
                                                                                            label={`${keyMapping[key]} *`}
                                                                                            required={true}
                                                                                            posting={state.posting}
                                                                                            value={state.input[key]}
                                                                                            error={state.errors[key]}
                                                                                            blurHandler={onInputBlur}
                                                                                            changeHandler={onChangeHandler}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>

                                                                    <div className="w-full my-6 rounded-md px-2 py-3 bg-slate-100 dark:bg-slate-800/70 text-slate-700 dark:text-slate-300">
                                                                        <h1 className="heading flex align-middle items-center pb-2">
                                                                            <div className="w-10 flex align-middle items-center">
                                                                                <span className="fa-duotone block mx-auto fa-circle-info fa-lg"></span>
                                                                            </div>

                                                                            <div className="flex-1 overflow-hidden">
                                                                                <span className="text-sm md:block flex gap-x-3">
                                                                                    Register the redirect URL below in your Google Cloud Console:
                                                                                </span>
                                                                            </div>
                                                                        </h1>

                                                                        <div className="relative w-full">
                                                                            <div className="flex items-center align-middle bg-slate-100 dark:bg-slate-900 my-2 border border-slate-300 dark:border-slate-600 text-slate-600 dark:text-white text-sm px-2 py-1 rounded-md gap-x-2">
                                                                                <pre className="overflow-hidden">
                                                                                    <code className="flex items-center align-middle">
                                                                                        {redirectURL}
                                                                                    </code>
                                                                                </pre>

                                                                                <div className="flex-none">
                                                                                    <span className="fa-duotone fa-copy fa-lg" onClick={copyRedirectURLHandler}></span>
                                                                                </div>
                                                                            </div>

                                                                            {
                                                                                copied && (
                                                                                    <div className="absolute top-0 right-0 -translate-y-full text-green-600 text-sm px-2 py-1 bg-white dark:bg-slate-800 rounded shadow animate-slide-up-fade">
                                                                                        ✅ Copied!
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div>

                                                    <div className="flex-none w-full lg:w-3/5 md:pb-4 pb-20 md:pt-4 pt-2">
                                                        {
                                                            state.selected.provider && (
                                                                <div className="flex flex-row-reverse items-center align-middle gap-x-3">
                                                                    <button type="button" className="text-sm flex-none shadow-none px-3 py-1 bg-inherit text-primary dark:text-gray-400 hover:text-secondary dark:hover:text-gray-300 hover:underline hover:cursor-pointer sm:w-auto sm:text-sm" onClick={checkIfFormIsPostingData}>
                                                                        Cancel
                                                                    </button>

                                                                    <button type="submit" className="w-auto min-w-24 justify-center disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-sm px-2.5 py-1.5 bg-orange-600 dark:bg-orange-600 text-white hover:bg-secondary dark:hover:bg-primary focus:outline-none">
                                                                        {
                                                                            state.posting ? (
                                                                                <span className="flex flex-row items-center h-5 justify-center">
                                                                                    <i className="fad fa-spinner-third fa-xl fa-spin"></i>
                                                                                </span>
                                                                            ) : (
                                                                                'Add Provider'
                                                                            )
                                                                        }
                                                                    </button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="w-4 md:block hidden"></div>
                                    </div>
                                </>
                            ) : (
                                <div className="py-2 px-6 w-full mx-auto h-full flex flex-col items-center justify-center align-middle">
                                    <Loading />
                                </div>
                            )
                        }
                    </>
                }
            />
        </React.Fragment>
    )
}